import React from "react";
import { SectionTitle } from "../../components";
import Layout from "../../layouts/Layout";
import { AllFaqs } from "../../containers";
const Faqs = () => {
  return (
    <>
      <Layout title={"Faqs"}>
        <div className="dg__market__data pt--130 pb--80">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <SectionTitle title={"FREQUENTLY ASKED QUESTIONS"} />

                <AllFaqs />
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default Faqs;
